export const INVOICE_DRAFT_MENU_OPTIONS = {
  GUARDAR: 0,
  VISTA_PREVIA: 1,
  DESCARGAR_PDF: 2,
} as const

export const INVOICES_TABLE_TABS = {
  CFDIS: 0,
  PREFACTURAS: 1,
} as const

export const CFDIS_ZIP_UPLOAD_CATEGORIES = {
  SUCCESS: 0,
  DUPLICATED: 1,
  FORMAT_ERROR: 2,
  GENERIC_ERROR: 3,
} as const
